export default __webpack_public_path__ + "static/media/01.dcef8fc1.jpg";